import { createSlice } from "@reduxjs/toolkit";

const authSlice = createSlice({
  name: "auth",
  initialState: {
    isAuthenticated: false,
    user: null,
    sessionId: null,
  },
  reducers: {
    login: (state, action) => {
      state.isAuthenticated = true;
      state.sessionId = action.payload.sessionId;
      state.user = action.payload.admin;

      localStorage.setItem("user", JSON.stringify(action.payload.admin));
      localStorage.setItem("sessionId", action.payload.sessionId);
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.sessionId = null;
      state.user = null;

      // Clear all authentication data from localStorage
      localStorage.removeItem("sessionId");
      localStorage.removeItem("user");
      localStorage.clear(); // Clear any other potential auth-related data
    },
    // Action to check if session is still valid
    validateSession: (state) => {
      const sessionId = localStorage.getItem("sessionId");
      const user = localStorage.getItem("user");

      if (sessionId && user) {
        try {
          const userData = JSON.parse(user);
          state.isAuthenticated = true;
          state.sessionId = sessionId;
          state.user = userData;
        } catch (error) {
          // Invalid user data, clear everything
          state.isAuthenticated = false;
          state.sessionId = null;
          state.user = null;
          localStorage.removeItem("sessionId");
          localStorage.removeItem("user");
        }
      }
    },
    // Action to refresh user data with current session
    refreshUser: (state, action) => {
      if (state.isAuthenticated && action.payload) {
        state.user = action.payload;
        localStorage.setItem("user", JSON.stringify(action.payload));
      }
    },
  },
});

export const { login, logout, validateSession, refreshUser } =
  authSlice.actions;
export default authSlice.reducer;
